export default __webpack_public_path__ + "static/media/banner.2797da92.png";